import colors from 'styles/colors';

const Compare = () => {
  return (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g className="fill">
        <path
          d="M0 2C0 0.89543 0.895431 0 2 0H7C8.10457 0 9 0.895431 9 2V6H0V2Z"
          strokeWidth="0"
          fill={colors.secondary.deepCove}
        />
        <path
          d="M11 2C11 0.89543 11.8954 0 13 0H18C19.1046 0 20 0.895431 20 2V6H11V2Z"
          strokeWidth="0"
          fill={colors.secondary.deepCove}
        />
      </g>
      <path
        d="M19 15C19 15.5523 18.5523 16 18 16L13 16C12.4477 16 12 15.5523 12 15L12 4L19 4L19 15Z"
        strokeWidth="2"
        stroke={colors.secondary.deepCove}
      />
      <path
        d="M8 15C8 15.5523 7.55228 16 7 16L2 16C1.44771 16 0.999999 15.5523 0.999999 15L1 4L8 4L8 15Z"
        strokeWidth="2"
        stroke={colors.secondary.deepCove}
      />
    </svg>
  );
};

export default Compare;
